<div class="range-slider">
    <input class="range-slider__range" [ngStyle]="{'background-color': textColor}" [ngClass]="{'range-slider__range_small': (isSmall()),'inactive':inactive}"
        type="range" [value]="val" [min]="min" [max]="max" [disabled]="'true'">
    <img class="range_image" [src]="getSliderImageSrc(val)" style="width:100%">
</div>
